import { render } from "./ProductAttributeShowComponent.vue?vue&type=template&id=07df063c"
import script from "./ProductAttributeShowComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttributeShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductAttribute/ProductAttributeShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07df063c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07df063c', __exports__)) {
    api.reload('07df063c', __exports__)
  }
  
  module.hot.accept("./ProductAttributeShowComponent.vue?vue&type=template&id=07df063c", () => {
    api.rerender('07df063c', render)
  })

}


export default __exports__